<script>
	// import Button from '$lib/Components/Layo	ut/Button/Button.svelte';
	import ColumnLayout from '$lib/Components/Layout/ColumnLayout/ColumnLayout.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import CostCards from './CostCards.svelte';
	import Heading from './Heading.svelte';
	import window from './images/window-measurements-white-line.png';

	let { version = 1, backgroundColor = 'white', page = 'default' } = $props();

	// builder
	let heading = $state('default');
	// let href = '/instant-estimate';
	let cards = $state({});
	// let buttonText = 'USE OUR PRICING CALCULATOR';
	if (version == 2 && page == 'sleep-panel') {
		heading = 'sleep-panel';
		// href = '/resources/case-studies';
		cards = { sleepPanel: true, commercial: false };
		// buttonText = 'READ CUSTOMER REVIEWS';
	}
</script>

{#if version == 1}
	<Section {backgroundColor}>
		<div class="container">
			<ColumnLayout columns={2} rows={1}>
				<li>
					<a href="/indow-cost">
						<Image
							src={window}
							alt="Illustration of an Indow insert being placed in a 3' by 4' window."
						/>
					</a>
				</li>
				<li>
					<p class="side-text title">What Do They Cost?</p>
					<p class="side-text">
						Indow Performance Grades start at $40 MSRP per sq ft. That's $480
						MSRP for a 3'x4' window opening.*
					</p>
					<p class="side">
						Consider the cost and distruption of replacing your windows. The
						national average for a vinyl window is $66-$87 per sq ft and wooden
						incased windows average $71-$109 per sq ft.
					</p>
					<p class="side">
						<a href="/indow-cost" class="white-link">Get a Free Estimate</a>
					</p>
					<p class="text-left text-sm italic">
						*Sales tax & shipping charges not included. Shipping charges vary by
						region and order size – talk to a Fit Specialist to get our best
						pricing.
					</p>
				</li>
			</ColumnLayout>
		</div>
	</Section>
{:else if version == 2}
	<Section {backgroundColor}>
		<h2>What Do They Cost?</h2>
		<Heading {heading} />
		<CostCards {cards} />
		<p>
			When you measure your windows, you’ll have help at every step. First, we
			have a library of video and written tutorials available. Second, our
			amazing team is always ready to take your call if you need assistance.
			Third, our proprietary measurement software will automatically check your
			measurements as you enter them to ensure a tight, snug fit for your custom
			window insert.
		</p>
		<p class="text-left text-sm italic">
			*Sales tax & shipping charges not included. Shipping charges vary by
			region and order size – talk to a Fit Specialist to get our best pricing.
		</p>
		<!-- <p class="text-lg font-semibold">
			Our Pricing Calculator is currently unavailable. <a href="/indow-cost"
				>Contact us</a
			> to discuss pricing.
		</p>
		<Button {href}>
			<slot name="buttonText">{buttonText}</slot>
		</Button> -->
	</Section>
{/if}

<style>
	.container {
		margin: 2.5rem 0;
	}
	.side-text {
		font-size: 1.75rem;
		font-weight: lighter;
		text-align: left;
	}
	.title {
		font-size: 2.25rem;
	}
	.side {
		text-align: left;
	}
	.white-link,
	a {
		font-weight: bold;
	}
	@media only screen and (max-width: 50rem) {
		.side {
			text-align: center;
			line-height: 1.5rem;
		}

		.title {
			line-height: 2.15rem;
		}

		.side-text {
			text-align: center;
			line-height: 2rem;
		}
	}
</style>
